Ext.define('WindowOperatorGroupsAddEdit', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.grupa.capitalise() + " (" + Lang.operatorzy + ")",
    width: 400,
    closable: false,
    collapsible: false,
    scrollable: false,
    modal: true,
    resizable: false,
    layout: 'fit',
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'panel',
            layout: 'column',
            items: [{
                columnWidth: 1,
                xtype: 'form',
                id: this.cid + 'formpanel',
                bodyStyle: 'padding:10px 10px 0px 10px',
                defaults: {
                    anchor: "0",
                    labelWidth: 150
                },
                items: [{
                    id: this.cid + "nazwa",
                    name: "nazwa",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.nazwa,
                    allowBlank: false,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + "idparent",
                    name: "idparent",
                    fieldLabel: Lang.grupa_nadrzedna,
                    allowBlank: AppOPERATORROLA == Const.OPERATOR_P_SERWIS,
                    xtype: "comboexd",
                    minChars: 1,
                    editable: true,
                    store: Ext.create('Ext.data.Store', {
                        fields: ['id', 'nazwa'],
                        proxy: {
                            type: 'ajax',
                            url: 'rest/grupyoperators/getParentsList',
                            actionMethods: {
                                read: 'POST'
                            },
                            reader: {
                                type: 'json',
                                rootProperty: 'data'
                            }
                        },
                        listeners: {
                            load: function (store) {
                                if (AppOPERATOR.idgrupa == null) {
                                    store.insert(0, {id: 0, nazwa: Lang.brak});
                                }
                            }
                        },
                        autoLoad: false
                    }),
                    blankText: Lang.pole_nie_moze_byc_puste,
                    displayField: 'nazwa',
                    valueField: 'id',
                    forceSelection: true,
                    value: AppOPERATOR.idgrupa == null ? 0 : null
                }, {
                    id: this.cid + 'role',
                    xtype: 'comboexd',
                    store: new Ext.data.ArrayStore({
                        data: [],
                        fields: ["value", "text"]
                    }),
                    displayField: "text",
                    valueField: "value",
                    triggerAction: 'all',
                    resizable: false,
                    mode: "local",
                    editable: false,
                    fieldLabel: Lang.rola,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + 'poziom',
                    xtype: 'comboexd',
                    store: new Ext.data.ArrayStore({
                        data: [[-1, Lang.brak], [Const.OPERATOR_P_KDP_SERWIS, Lang.serwis], [Const.OPERATOR_P_KDP_ADMIN, Lang.administrator], [Const.OPERATOR_P_KDP_OPERATOR, Lang.operator], [Const.OPERATOR_P_KDP_SKP, Lang.operator_skp], [Const.OPERATOR_P_KDP_RAPORT, Lang.raport], [Const.OPERATOR_P_KDP_DOSTAWCA, Lang.dostawca], [Const.OPERATOR_P_KDP_NOACCESS, Lang.brak_dostepu]],
                        fields: ["value", "text"]
                    }),
                    displayField: "text",
                    valueField: "value",
                    triggerAction: 'all',
                    resizable: false,
                    mode: "local",
                    editable: false,
                    frame: false,
                    border: false,
                    value: -1,
                    fieldLabel: Lang.poziom_w_sterowniku,
                    hidden: Const.SKPFLAG || Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || AppFIRMACTX != null
                }, {
                    id: this.cid + "notifications",
                    name: "notifications",
                    xtype: "button",
                    margin: 15,
                    text: Lang.powiadomienia_grupowe,
                    scope: this,
                    handler: function () {
                        var windowEmailConfig = Ext.create('WindowEmailConfig');
                        windowEmailConfig.showWOperatorGroup(this.obiektid);
                    }
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        if (!validPrivilegesOperatorComplex('access.manage.grupyoperators')) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.obiektid = obiektid;
        this.obiekt = null;
        sendAjaxDataJsonRpcL("rest/grupyoperators/getObjectForEdit", {
            id: obiektid
        }, this, function (data) {
            if (data.status) {
                this.obiekt = data.data;
                this.show();
                this.center();
                this.setKeyMap({
                    'ESC': {
                        scope: this,
                        handler: this.closeOp
                    }
                });
                var parentStore = Ext.getCmp(this.cid + "idparent").getStore();
                parentStore.getProxy().setExtraParams({
                    id: this.obiektid
                });
                parentStore.load();
                var store = Ext.getCmp(this.cid + "role").getStore();
                let customRolesList = [];
                let defaultRolesList = [];
                let emptyRec = {value: -1, text: Lang.brak};
                store.loadData([emptyRec], true)
                sendAjaxDataJsonRpcL("rest/operators/getDefaultRolesList", null, this, function (defaultRolesData) {
                    if (defaultRolesData.status) {
                        if (defaultRolesData.data != null) {
                            defaultRolesData.data.forEach(record => {
                                if (record.poziom >= AppOPERATORHPOZIOM) {
                                    let modifiedRecord = {
                                        value: record.id,
                                        text: OPERATOR_ROLES_DATA.find(role => role[0] == record.id)[1] + ' (' + record.poziom + ')'
                                    };
                                    defaultRolesList.push(modifiedRecord);
                                }
                            });
                            store.loadData(defaultRolesList, true);
                        }
                        sendAjaxDataJsonRpcL("rest/ownoprole/getList", null, this, function (customRolesData) {
                            if (customRolesData.status) {
                                if (customRolesData.data != null) {
                                    customRolesData.data.forEach(record => {
                                        if (Const.PROFLAG || Const.ENTERPRISEFLAG) {
                                            if (record.poziom >= AppOPERATORHPOZIOM) {
                                                let modifiedRecord = {
                                                    value: record.id + 1000,
                                                    text: record.nazwa + ' (' + record.poziom + ')'
                                                };
                                                customRolesList.push(modifiedRecord);
                                            }
                                        }
                                    });
                                    store.loadData(customRolesList, true);
                                }
                                if (!AppOPERATORROLA == Const.OPERATOR_P_SERWIS) {
                                    this.removeRolesForOperatorWithFirm([Const.OPERATOR_P_SERWIS]);
                                }
                                if (AppOPERATORROLA != Const.OPERATOR_P_SERWIS) {
                                    this.removeRolesForOperatorWithFirm([Const.OPERATOR_P_API]);
                                }
                                this.removeRolesForOperatorWithFirm([Const.OPERATOR_P_CUSTOM]);
                                if (Const.ENTERPRISEFLAG && (AppFIRMACTX != null || (this.obiekt && this.obiekt.firma != null))) {
                                    this.removeRolesForOperatorWithFirm([Const.OPERATOR_P_SERWIS, Const.OPERATOR_P_ADMIN, Const.OPERATOR_P_DOSTAWCA]);
                                }
                                if (!Const.CLOUDFLAG) {
                                    this.removeRolesForOperatorWithFirm([Const.OPERATOR_P_CLOUD]);
                                }
                                if (Const.STARTERFLAG) {
                                    this.removeRolesForOperatorWithFirm([Const.OPERATOR_P_DOSTAWCA, Const.OPERATOR_P_CLOUD, Const.OPERATOR_P_RAPORT, Const.OPERATOR_P_OPERATOR]);
                                }
                                Ext.getCmp(this.cid + "role").setValue2(-1);
                                if (this.obiekt != null) {
                                    Ext.getCmp(this.cid + "poziom").setValue2(this.obiekt.poziom != null ? this.obiekt.poziom : -1);
                                    Ext.getCmp(this.cid + "role").setValue2(this.obiekt.role != null ? this.obiekt.role : -1);
                                    Ext.getCmp(this.cid + "nazwa").setValue(this.obiekt.nazwa);
                                    Ext.getCmp(this.cid + "idparent").setValue(this.obiekt.idparent);
                                    Ext.getCmp(this.cid + "idparent").valueNotFoundText = this.obiekt.idparent;
                                    Ext.getCmp(this.cid + "idparent").setHidden(AppOPERATOR.idgrupa == this.obiektid);
                                } else {
                                    Ext.getCmp(this.cid + "notifications").setHidden(true);
                                }
                            } else {
                                Ext.MessageBox.alert(Lang.error, data.error);
                            }
                        });
                    } else {
                        Ext.MessageBox.alert(Lang.error, data.error);
                    }
                });
                if (this.obiekt != null) {
                    Ext.getCmp(this.cid + "nazwa").setValue(this.obiekt.nazwa);
                    Ext.getCmp(this.cid + "idparent").setValue(this.obiekt.idparent);
                    Ext.getCmp(this.cid + "idparent").valueNotFoundText = this.obiekt.idparent;
                    Ext.getCmp(this.cid + "idparent").setHidden(AppOPERATOR.idgrupa == this.obiektid);
                } else {
                    Ext.getCmp(this.cid + "notifications").setHidden(true);
                }
            }
        });
    },
    saveOp: function () {
        if (!Ext.getCmp(this.cid + 'formpanel').form.isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }
        var idparent = Ext.getCmp(this.cid + "idparent").getValue2NL();
        var customrole = Ext.getCmp(this.cid + 'role').getValue() > 1000 ? Ext.getCmp(this.cid + 'role').getValue() - 1000 : null;
        var role = Ext.getCmp(this.cid + 'role').getValue()
        if (customrole != null || role === -1) {
            role = null;
        }
        var poziom = Ext.getCmp(this.cid + 'poziom').getValue();
        if (poziom === -1) {
            poziom = null;
        }
        sendAjaxDataJsonRpcL("rest/grupyoperators/saveObject", {
            id: this.obiektid,
            nazwa: Ext.getCmp(this.cid + "nazwa").getValue(),
            idparent: idparent,
            optlockversion: this.obiekt != null ? this.obiekt.optlockversion : null,
            role: role,
            poziom: poziom,
            customrole: customrole,
            type: this.type
        }, this, function (data) {
            if (data.status) {
                this.fireEvent("wclose");
                this.closeOp();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    removeRolesForOperatorWithFirm: function (rolesToDelete) {
        if (rolesToDelete == null || rolesToDelete.length == 0) {
            return;
        }
        var store = Ext.getCmp(this.cid + "role").getStore();
        var recordsToDelete = Ext.Array.filter(store.getData().items, function (item, index) {
            var del = false;
            rolesToDelete.forEach(function (roleToDelete) {
                if (roleToDelete == item.data.value) {
                    del = true;
                }
            })
            return del;
        });
        store.remove(recordsToDelete);
    },
    closeOp: function () {
        this.close();
    }
});

